import React from 'react';
import { UploadType } from '@wix/da-shared-react/pkg/redux/uploads/types';
import { FileUploadOptions } from '@wix/da-shared-react/pkg/utils/hooks/useFileUpload';
import DeviationDropZonePopup from '../DeviationDropZonePopup';
import OriginalsDeliveryDropZonePopup from '../OriginalsDeliveryDropZonePopup';

interface Props {
  uploadType: UploadType;
  uploadParams: FileUploadOptions['uploadParams'];
  tierId?: number;
  isPageLoadModal?: boolean;
  onDeviationCreated: (deviationId: number) => void;
  requestClose: () => void;
}

const DeviationDropZoneWrapper: React.FC<Props> = ({
  uploadType,
  uploadParams,
  ...props
}) => {
  if (
    uploadType === UploadType.ORIGINALS_DELIVERY &&
    uploadParams?.deviationId &&
    uploadParams?.orderId
  ) {
    return (
      <OriginalsDeliveryDropZonePopup uploadParams={uploadParams} {...props} />
    );
  }

  return <DeviationDropZonePopup {...props} />;
};

export default DeviationDropZoneWrapper;
